import { Sale } from 'shared/models';
import request from "../../features/auth/services/requester/user.request";
const saleService = {
  getSales: (params: any) => request.get<Sale[]>(`/sales`, { params }),
  getSaleById: (id: string) => request.get<Sale>(`/sale/user/${id}`),
};

export default saleService;
